import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function Desktop({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.75 2.25H2.25C1.425 2.25 0.75 2.925 0.75 3.75V12.75C0.75 13.575 1.425 14.25 2.25 14.25H6V15.75H12V14.25H15.75C16.575 14.25 17.2425 13.575 17.2425 12.75L17.25 3.75C17.25 2.925 16.575 2.25 15.75 2.25ZM15.75 12.75H2.25V3.75H15.75V12.75Z"
                fill={color}
            />
        </svg>
    );
}

export default Desktop;
